import { useEffect } from "react";

import { useChangeSelectedCompanyStore } from "@/stores/useChangeSelectedCompanyStore";

import { useAuth } from "../../context/Auth/AuthProvider";
import useRefreshDashboardData from "../../shared/hooks/useRefreshDashboardData";

interface DashboardWrapperProps {
  children: React.ReactNode;
}

const DashboardWrapper = ({ children }: DashboardWrapperProps) => {
  const { user } = useAuth();
  const { finishLoadingIfAllDataIsFetched, refreshDashboardData } =
    useRefreshDashboardData();

  const isChangeSelectedCompany = useChangeSelectedCompanyStore(
    state => state.isChangeSelectedCompany
  );

  const setIsChangeSelectedCompany = useChangeSelectedCompanyStore(
    state => state.setIsChangeSelectedCompany
  );

  useEffect(() => {
    isChangeSelectedCompany && refreshDashboardData(); // refresh dashboard when user data changes
    setIsChangeSelectedCompany(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, setIsChangeSelectedCompany]);

  useEffect(() => {
    finishLoadingIfAllDataIsFetched();
  }, [finishLoadingIfAllDataIsFetched]);

  return <>{children}</>;
};

export default DashboardWrapper;
